export type FeatureSwitches = {
  userSwitches: string[];
  schoolSwitches: string[];
  classroomSwitches: string[];
  communitySwitches: string[];
  classOwnerSwitches: string[];
};

export const SCHOOL_FEATURE_SWITCHES = {
  // Tap causes monster to walk straight to destination with auto-jumps, rather than A-star pathfinding.
  MONSTERVERSE_DIRECT_TAP_TO_MOVE_S: "monsterverseDirectTapToMoveS",

  // Block Building Features
  MONSTERVERSE_ENABLE_ALL_BLOCKS: "monsterverseEnableAllBlocks",

  // Renderering tech
  MONSTERVERSE_USE_CACHED_MESH: "monsterverseUseCachedMesh",
  MONSTERVERSE_USE_DECALS: "monsterverseUseDecals",
  MONSTERVERSE_USE_TERRAIN_MULTIDRAW: "monsterverseUseTerrainMultiDraw",
  MONSTERVERSE_USE_PROPS_MULTIDRAW: "monsterverseUsePropsMultiDraw",
  MONSTERVERSE_USE_BRICKS_AO: "monsterverseUseBricksAO",
  MONSTERVERSE_PATHFINDING_MATH_V2_BUGFIX: "monsterversePathfindingMathV2Bugfix",
  MONSTERVERSE_RENDER_PASSES: "monsterverseRenderPasses",

  // State Graph Features
  MONSTERVERSE_STATE_GRAPH_DB: "monsterverseStateGraphDb",

  // World Building Team Features
  MONSTERVERSE_WORLD_BUILDING_PROTOTYPES: "monsterverseWorldBuildingPrototypes",

  MONSTERVERSE_SHOW_UGC_REPORTING: "monsterverseUgcReporting",

  MONSTERVERSE_INTERNAL_SHARE_LINK: "monsterverseInternalShareLink",
};

export const USER_FEATURE_SWITCHES = {
  MONSTERVERSE_DIRECT_TAP_TO_MOVE: "monsterverseDirectTapToMove",

  MONSTERVERSE_RIVE_EMOJI_ICON: "monsterverseRiveEmojiIcon2",

  MONSTERVERSE_CREATIVE_MODE: "monsterverseCreativeMode",

  MONSTERVERSE_TEACHER_FTUE: "monsterverseTeacherFtue",
};

export const CLASSROOM_FEATURE_SWITCHES = {
  MONSTERVERSE_DIRECT_TAP_TO_MOVE_C: "monsterverseDirectTapToMoveC",

  // Math Zone
  MV_MATH_V2: "monsterverseMathV2Activity",
  MV_MATH_V2_CLASSROOM_PLAYTEST: "monsterverseMathV2ClassroomPlaytest",

  MONSTERVERSE_SCHOOL_ACTIVITY_ARENA: "schoolActivityArena",
};

export const COMMUNITY_FEATURE_SWITCHES = {
  MONSTERVERSE_DIRECT_TAP_TO_MOVE_H: "monsterverseDirectTapToMoveH",

  MONSTERVERSE_HOME_ACTIVITY_TAG: "homeActivityTag",
  MONSTERVERSE_HOME_ACTIVITY_ARENA: "homeActivityArena",
  MONSTERVERSE_HOME_ACTIVITY_TAGV2: "homeActivityTagv2",
  MONSTERVERSE_HOME_UNLIMITED_BLOCKS: "monsterverseHomeUnlimitedBlocks",
};

// Used to support a Mentor Beta program that opts in features based on the owner of a class.
export const CLASS_OWNER_FEATURE_SWITCHES = {};

export const FEATURE_SWITCHES = {
  ...USER_FEATURE_SWITCHES,
  ...SCHOOL_FEATURE_SWITCHES,
  ...CLASSROOM_FEATURE_SWITCHES,
  ...COMMUNITY_FEATURE_SWITCHES,
  ...CLASS_OWNER_FEATURE_SWITCHES,
};

export const FEATURE_SWITCHES_TO_CHECK: FeatureSwitches = {
  userSwitches: Object.values<string>(USER_FEATURE_SWITCHES),
  schoolSwitches: Object.values<string>(SCHOOL_FEATURE_SWITCHES),
  classroomSwitches: Object.values<string>(CLASSROOM_FEATURE_SWITCHES),
  communitySwitches: Object.values<string>(COMMUNITY_FEATURE_SWITCHES),
  classOwnerSwitches: Object.values<string>(CLASS_OWNER_FEATURE_SWITCHES),
};

//Feature switches shown in the editor's Visibility menu
export const EDITOR_FEATURE_SWITCHES = ["spookySeason", "fallSeason", "winterSeason"];
